import { createFileRoute } from "@tanstack/react-router";
import AdminContentDetailPage from "@/pages/admin/content/detail";
import { useContentPermissions } from "@/pages/admin/content";

export const Route = createFileRoute("/app/admin/content/$contentId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { contentId } = Route.useParams();
  const { userCanEditAllContent, userCanViewAllContent } = useContentPermissions();

  return (
    <AdminContentDetailPage
      id={Number(contentId)}
      userCanEditAllContent={userCanEditAllContent}
      userCanViewAllContent={userCanViewAllContent}
    />
  );
}
